import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { server } from "../../../src/server";
import FlexBetween from "components/FlexBetween";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { toast } from "react-toastify";

const ImpressionEdit = () => {
  const { id } = useParams();
  const [impression, setImpression] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [formData, setFormData] = useState({
    nameImpression: "",
    price: 0,
  });

  useEffect(() => {
    const fetchPapier = async () => {
      const IdImpression = localStorage.getItem("impressionId");
      try {
        const response = await axios.get(
          `${server}/impression/get-impression/${IdImpression}/${id}`
        );
        setImpression(response.data.impression);
        // Populate formData with initial values from prestation
        setFormData({
          nameImpression: response.data.impression.nameImpression,
          price: response.data.impression.price,
        });
      } catch (error) {
        setError("Error fetching paper");
      } finally {
        setLoading(false);
      }
    };

    fetchPapier();
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const IdImpression = localStorage.getItem("impressionId");
      const response = await axios.put(
        `${server}/impression/update-impression/${IdImpression}/${id}`,
        formData
      );
      toast.success("Impression updated successful");
      setTimeout(() => {
        window.location.replace("/impression");
      }, 1000);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {impression ? (
        <div>
          <Box m="20px">
            <FlexBetween>
              <Header title="LES DETAILS DU TYPE D'IMPRESSION" />
            </FlexBetween>

            <Formik>
              {({ values, errors, touched, handleBlur, handleChange }) => (
                <form onSubmit={handleUpdate}>
                  <Box
                    display="grid"
                    marginTop="20px"
                    gap="30px"
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="filled"
                      type="string"
                      label={`Nom : ${impression.nameImpression} `}
                      value={formData.nameImpression}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          nameImpression: e.target.value,
                        })
                      }
                      name="Nom"
                      sx={{ gridColumn: "span 2" }}
                    />
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label={`le prix : ${impression.price} `}
                      value={formData.price}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          price: parseInt(e.target.value),
                        })
                      }
                      name="le prix"
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Box>
                  <Box display="flex" justifyContent="end" mt="20px">
                    <Button color="secondary" variant="contained" type="submit">
                      Mettre à jour ce type d'impression
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        </div>
      ) : (
        <div>No printing type found</div>
      )}
    </div>
  );
};

export default ImpressionEdit;
